import React, { useState } from "react";
import { Modal, ModalBody, Input, Label, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";

//Import Images
import jobImages2 from "../../../assets/images/matrix-logo.webp";

const RightSideContent = ({ jobDetails, onApplyClick }) => {
    const [modal, setModal] = useState(false);
    const openModal = () => setModal(!modal);
    // Fallback if data is missing
    const {
        ID,
        JobTitle,
        ExperienceRequired,
        OfferSalary,
        Qualifications,
        PositionLevel,
        CreatedAt,
        CompanyLogo,
        CompanyName,
        ContactPhone = "+1 (234) 223 1245",
        ContactEmail = "info@matrixexecutivesearch.com",
        Website = "www.matrixexecutivesearch.com",
        JobLocation,
        State,
        Industry,
    } = jobDetails || {};

    return (
        <React.Fragment>
            <div className="side-bar ms-lg-4">
                <Card className="job-overview">
                    <CardBody className="p-4">
                        <h6 className="fs-17">Job Overview</h6>
                        <ul className="list-unstyled mt-4 mb-0">
                            <li>
                                <div className="d-flex mt-4">
                                    <i className="uil uil-user icon bg-primary-subtle text-primary" style={{ minWidth: '45px', maxHeight: '50px' }}></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-01">Job Title</h6>
                                        <p className="text-muted mb-0">{JobTitle}</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="d-flex mt-4">
                                    <i className="uil uil-star-half-alt icon bg-primary-subtle text-primary"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-1">Experience</h6>
                                        <p className="text-muted mb-0">{ExperienceRequired}</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="d-flex mt-4">
                                    <i className="uil uil-location-point icon bg-primary-subtle text-primary"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-1">Location</h6>
                                        <p className="text-muted mb-0">{JobLocation || "N/A"}{', ' + State || ""}</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="d-flex mt-4">
                                    <i className="uil uil-usd-circle icon bg-primary-subtle text-primary"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-1">Offered Salary</h6>
                                        <p className="text-muted mb-0">${OfferSalary}</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="d-flex mt-4">
                                    <i className="uil uil-graduation-cap icon bg-primary-subtle text-primary"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-1">Qualification</h6>
                                        <p className="text-muted mb-0">{Qualifications?.slice(0, 26)}</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="d-flex mt-4">
                                    <i className="uil uil-building icon bg-primary-subtle text-primary"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-1">Industry</h6>
                                        <p className="text-muted mb-0">{Industry || "N/A"}</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="d-flex mt-4">
                                    <i className="uil uil-history icon bg-primary-subtle text-primary"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-1">Date Posted</h6>
                                        <p className="text-muted mb-0">
                                            {new Date(CreatedAt).toLocaleDateString()}
                                        </p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div className="mt-3">
                            <Link
                                to="#"
                                onClick={() => onApplyClick(jobDetails)}
                                className="btn btn-primary btn-hover w-100 mt-2"
                            >
                                Apply Now <i className="uil uil-arrow-right"></i>
                            </Link>
                            {/* <Link
                                to="/bookmarkjobs"
                                className="btn btn-soft-warning btn-hover w-100 mt-2"
                            >
                                <i className="uil uil-bookmark"></i> Add Bookmark
                            </Link> */}
                        </div>
                    </CardBody>
                </Card>

                <Card className="company-profile mt-4">
                    <CardBody className="p-4">
                        <div className="text-center">
                            <img
                                src={jobImages2}
                                alt="Company"
                                className="img-fluid rounded-3"
                                draggable={false}
                                style={{ maxWidth: '220px' }}
                            />
                            <div className="mt-4">
                                <h6 className="fs-17 mb-1">{CompanyName}</h6>
                                {/* update 2017 to 2009 */}
                                <p className="text-muted">Since July 2009</p>
                            </div>
                        </div>
                        <ul className="list-unstyled mt-4">
                            <li>
                                <div className="d-flex">
                                    <i className="uil uil-phone-volume text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-1">Phone</h6>
                                        <p className="text-muted fs-14 mb-0">{ContactPhone}</p>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-3">
                                <div className="d-flex">
                                    <i className="uil uil-envelope text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-1">Email</h6>
                                        <p className="text-muted fs-14 mb-0">{ContactEmail}</p>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-3">
                                <div className="d-flex">
                                    <i className="uil uil-globe text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-1">Website</h6>
                                        <p className="text-muted fs-14 text-break mb-0">{Website}</p>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-3">
                                <div className="d-flex">
                                    <i className="uil uil-map-marker text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-1">Location</h6>
                                        <p className="text-muted fs-14 mb-0">{JobLocation}, {State}</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div className="mt-4">
                            <Link to="/contact-us" className="btn btn-primary btn-hover w-100 rounded">
                                Contact us
                            </Link>
                        </div>
                    </CardBody>
                </Card>

                {/* Map and Modal remain the same */}
                {/* ... */}
            </div>
        </React.Fragment >
    );
};

export default RightSideContent;
